import { lazy, Suspense } from "react";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { PageBackground } from "@/components/layout/PageBackground";
import { MarbleHero } from "@/components/home/MarbleHero";
import { StatsBar } from "@/components/home/StatsBar";
import { HomeSchema } from "@/components/seo/HomeSchema";
import { SEOHead } from "@/components/seo/SEOHead";

// Lazy load below-fold sections for faster initial page load
const ClientLogos = lazy(() => import("@/components/home/ClientLogos").then(m => ({ default: m.ClientLogos })));
const ValueProposition = lazy(() => import("@/components/home/ValueProposition").then(m => ({ default: m.ValueProposition })));
const Services = lazy(() => import("@/components/home/Services").then(m => ({ default: m.Services })));
const BeforeAfterSlider = lazy(() => import("@/components/home/BeforeAfterSlider").then(m => ({ default: m.BeforeAfterSlider })));
const WhyChooseUs = lazy(() => import("@/components/home/WhyChooseUs").then(m => ({ default: m.WhyChooseUs })));
const HomeSearchIntents = lazy(() => import("@/components/home/HomeSearchIntents").then(m => ({ default: m.HomeSearchIntents })));
const GoogleReviews = lazy(() => import("@/components/home/GoogleReviews").then(m => ({ default: m.GoogleReviews })));
const BlogCTA = lazy(() => import("@/components/home/BlogCTA").then(m => ({ default: m.BlogCTA })));
const BlogPreview = lazy(() => import("@/components/home/BlogPreview").then(m => ({ default: m.BlogPreview })));
const CTA = lazy(() => import("@/components/home/CTA").then(m => ({ default: m.CTA })));

const Index = () => {
  return (
    <PageBackground>
      <SEOHead
        title="Lazona Tile Care | Tile, Grout & Stone Restoration Arizona"
        description="Tile, grout and stone restoration in Chandler, Gilbert and Mesa since 2016. IICRC certified. 15-year homeowner warranty on grout color sealing."
        canonical="/"
      />
      <HomeSchema />
      <Header />
      <main>
        <MarbleHero />
        <StatsBar />
        <Suspense fallback={null}>
          <ClientLogos />
          <BlogCTA />
          <ValueProposition />
          <Services />
          <BeforeAfterSlider />
          <WhyChooseUs />
          <HomeSearchIntents />
          <GoogleReviews />
          <BlogPreview />
          <CTA />
        </Suspense>
      </main>
      <Footer />
    </PageBackground>
  );
};

export default Index;
